
/* EMPLOYER PAYROLL TYPES */
export const GET_EMPLOYER_ESIGN= "GET_EMPLOYER_ESIGN"
export const GET_EMPLOYER_ESIGN_SUCCESS = "GET_EMPLOYER_ESIGN_SUCCESS"
export const GET_EMPLOYER_ESIGN_FAIL = "GET_EMPLOYER_ESIGN_FAIL"

export const UPLOAD_EMPLOYER_ESIGN= "UPLOAD_EMPLOYER_ESIGN"
export const UPLOAD_EMPLOYER_ESIGN_SUCCESS = "UPLOAD_EMPLOYER_ESIGN_SUCCESS"
export const UPLOAD_EMPLOYER_ESIGN_FAIL = "UPLOAD_EMPLOYER_ESIGN_FAIL"
